var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('p',{staticClass:"level-item"},[_c('b-button',{attrs:{"tag":"router-link","type":"is-success","to":{ name: 'tutorial.add' },"icon-left":"plus","label":"Nouveau"}})],1)]),_vm._v(" "),_c('div',{staticClass:"level-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }